'use client';

import Image from 'next/image';
import { useIntl } from 'react-intl';
import { subscriptionBadgeSizeToPx } from '../logoBadgeSizeToPx';
import { SubscriptionBadgeBadgeProps } from '../types';
import peakIconSrc from './peak-icon.svg';
import peakIconCircleSrc from './peak-icon-circle.svg';
import peakFullLightTextSrc from './peak-full-light-text.svg';
import peakFullDarkTextSrc from './peak-full-dark-text.svg';

const getSvgSrc = ({ variant, textColor }: SubscriptionBadgeBadgeProps) => {
  switch (variant) {
    case 'icon':
      return peakIconSrc;
    case 'icon-circle':
      return peakIconCircleSrc;
    case 'full':
      if (textColor === 'light') {
        return peakFullLightTextSrc;
      }
      return peakFullDarkTextSrc;
    default:
      return peakFullDarkTextSrc;
  }
};

const PeakLogoBadge = ({ className, size = 'md', variant, textColor }: SubscriptionBadgeBadgeProps) => {
  const intl = useIntl();
  return (
    <Image
      className={className}
      src={getSvgSrc({ variant, textColor })}
      height={subscriptionBadgeSizeToPx[size]}
      alt={intl.formatMessage({ defaultMessage: '{tier} badge image' }, { tier: 'Peak' })}
    />
  );
};

export default PeakLogoBadge;
